export default __webpack_public_path__ + "static/media/logo-bank-5.79882179.png";